import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useNavigate } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { api } from "../../redux/apis/api";
import { FormDateField } from "../../components/form/date";

const CreateExpense = () => {
  const naviagte = useNavigate();

  const initialValues = {
    title: "",
    amount: "",
    date: "",
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/expense/create`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        naviagte(`/expense/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                <h2 className="text-xl font-semibold capitalize">
                  Expense - Create
                </h2>
                <div className="flex gap-3 items-center">
                  <button
                    onClick={() => naviagte("/expense/list")}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    Create
                  </button>
                </div>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <FormTextField
                    name={"title"}
                    label={"title"}
                    placeholder={`Enter title`}
                  />
                </div>
                <div className="my-4">
                  <FormTextField
                    name={"amount"}
                    label={"amount"}
                    placeholder={`Enter amount`}
                  />
                </div>
                <div className="my-4">
                  <FormDateField name={"date"} label={"date"} />
                </div>

                <div className="my-4"></div>
              </section>
            </Form>
          )}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default CreateExpense;
